import { Globe2 } from 'lucide-preact'
import { memo } from 'preact/compat'
import { DashboardStatTile } from './DashboardStatTile'

interface ActiveWebsStatTileProps {
  count: number | null | undefined
  rangeLabel?: string
  loading?: boolean
  error?: string | null
  failed?: boolean
}

export const ActiveWebsStatTile = memo((props: ActiveWebsStatTileProps) => (
  <DashboardStatTile
    titleLines={['Active', 'Webs']}
    icon={<Globe2 className="w-5 h-5 text-primary-600 dark:text-primary-400" />}
    badge="Active"
    badgeTitle="Active webs currently live"
    {...props}
  />
))
